var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7393 0C59.3764 0 68 8.62359 68 19.2607V48.7393C68 59.3764 59.3764 68 48.7393 68H19.2607C8.62359 68 0 59.3764 0 48.7393V19.2607C0 8.62359 8.62359 0 19.2607 0H48.7393Z",
    fill: "#F2EAFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(16 16)",
    fill: "#F2EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7022 31.3567C49.1178 31.3842 48.6682 31.8877 48.6682 32.4727V41.1342L46.4951 43.3072L48.6682 45.4802H50.2979C50.598 45.4802 50.8412 45.237 50.8412 44.937V32.442C50.8412 31.8245 50.3261 31.3273 49.7022 31.3567Z",
    fill: "#D1B4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4953 38.9609H44.3223V47.6531H46.4953C47.6935 47.6531 48.6683 46.6783 48.6683 45.4801V41.134C48.6683 39.9358 47.6935 38.9609 46.4953 38.9609Z",
    fill: "#9FBAAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2982 31.3567C18.8826 31.3842 19.3322 31.8877 19.3322 32.4727V41.1342L21.5053 43.3072L19.3322 45.4802H17.7024C17.4024 45.4802 17.1592 45.237 17.1592 44.937V32.442C17.1592 31.8245 17.6743 31.3273 18.2982 31.3567Z",
    fill: "#D1B4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5051 38.9609H23.6781V47.6531H21.5051C20.3069 47.6531 19.332 46.6783 19.332 45.4801V41.134C19.332 39.9358 20.3069 38.9609 21.5051 38.9609Z",
    fill: "#9FBAAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0627 31.3555H38.8896L39.9762 51.9993H42.1492C44.5495 51.9993 46.4953 50.0535 46.4953 47.6533V36.7881C46.4953 33.7878 44.063 31.3555 41.0627 31.3555Z",
    fill: "#AB76FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3223 47.6533L42.1492 44.3937L44.3223 41.1341V36.7881C44.3223 33.7878 41.89 31.3555 38.8897 31.3555H36.7166L34.0003 33.5285L31.284 31.3555H26.938C23.9377 31.3555 21.5054 33.7878 21.5054 36.7881V47.6533C21.5054 50.0535 23.4512 51.9993 25.8514 51.9993H39.9762C42.3765 51.9993 44.3223 50.0535 44.3223 47.6533Z",
    fill: "#D1B4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7407 31.8987V36.2448C30.7407 36.5448 30.984 36.7881 31.284 36.7881H36.7166C37.0166 36.7881 37.2598 36.5448 37.2598 36.2448V31.8987C37.2598 31.5987 37.0166 31.3555 36.7166 31.3555H31.284C30.984 31.3555 30.7407 31.5987 30.7407 31.8987Z",
    fill: "#AB76FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9761 38.9609V49.8261H42.1491C43.3493 49.8261 44.3222 48.8533 44.3222 47.6531V41.134C44.3222 39.9338 43.3493 38.9609 42.1491 38.9609H39.9761Z",
    fill: "#597067"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6782 41.134V47.6531C23.6782 48.8533 24.6511 49.8261 25.8513 49.8261H39.976C41.1762 49.8261 42.149 48.8533 42.149 47.6531V41.134C42.149 39.9338 41.1762 38.9609 39.976 38.9609H25.8513C24.6511 38.9609 23.6782 39.9338 23.6782 41.134Z",
    fill: "#6B8279"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1109 44.9387C29.711 44.9387 30.1975 44.4522 30.1975 43.8521C30.1975 43.2521 29.711 42.7656 29.1109 42.7656C28.5109 42.7656 28.0244 43.2521 28.0244 43.8521C28.0244 44.4522 28.5109 44.9387 29.1109 44.9387Z",
    fill: "#AB76FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9763 43.8521C39.9763 44.4522 39.4898 44.9387 38.8897 44.9387C38.2897 44.9387 37.8032 44.4522 37.8032 43.8521C37.8032 43.2521 38.2897 42.7656 38.8897 42.7656C39.4898 42.7656 39.9763 43.2521 39.9763 43.8521Z",
    fill: "#AB76FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2217 16V25.9235H38.3947C39.5949 25.9235 40.5678 24.9507 40.5678 23.7505V18.173C40.5678 16.9729 39.5949 16 38.3947 16H36.2217Z",
    fill: "#FEC94F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2218 16H29.6061C28.406 16 27.4331 16.9729 27.4331 18.173V23.7505C27.4331 24.9507 28.406 25.9235 29.6061 25.9235H31.9243L32.9967 28.5124C33.3671 29.4066 34.6338 29.4066 35.0043 28.5124L36.0766 25.9235H36.2217C37.4219 25.9235 38.3948 24.9507 38.3948 23.7505V18.173C38.3948 16.9729 37.4219 16 36.2218 16Z",
    fill: "#FFDD57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 46.5678C33.0776 46.5678 32.2424 46.0211 31.8728 45.1751C31.7526 44.9002 31.878 44.5799 32.153 44.4598C32.4278 44.3394 32.7481 44.4651 32.8683 44.74C33.0651 45.1903 33.5094 45.4812 34.0003 45.4812C34.4912 45.4812 34.9355 45.1903 35.1323 44.7401C35.2523 44.4651 35.5726 44.3396 35.8476 44.4598C36.1226 44.5799 36.248 44.9002 36.1279 45.1751C35.7582 46.0211 34.9231 46.5678 34.0003 46.5678Z",
    fill: "#597067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/aiIcon.91c9a05a57265f3afe4348595b6b4612.svg";
export { ForwardRef as ReactComponent };